import { render } from "./DvvVeranstaltungen.pug?vue&type=template&id=61487079&lang=pug"
import script from "./DvvVeranstaltungen.js?vue&type=script&lang=js"
export * from "./DvvVeranstaltungen.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__